import { render, staticRenderFns } from "./AgentStat.vue?vue&type=template&id=70180fad&scoped=true"
import script from "./AgentStat.vue?vue&type=script&lang=js"
export * from "./AgentStat.vue?vue&type=script&lang=js"
import style0 from "./AgentStat.vue?vue&type=style&index=0&id=70180fad&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70180fad",
  null
  
)

export default component.exports